import { updateField } from 'vuex-map-fields';

export default {
  SET_INVOICES(state, payload) {
    state.invoiceList = payload;
    state.loadingData = false;
  },
  SET_INVOICE(state, payload) {
    state.invoice = payload;
  },
  SET_PUBLIC_INVOICE(state, payload) {
    state.publicInvoice = payload;
  },
  SET_NEXT_INVOICE_NUMBER(state, payload) {
    state.nextInvoiceNumber = payload.invoice_number;
  },
  SET_TOTAL_REVENUE(state, payload) {
    state.totalRevenue = payload.total_revenue;
  },
  SET_SUCCESS_CREATE(state, payload) {
    state.invoiceCreated = payload;
  },
  SET_SUCCESS_DELETE(state, payload) {
    state.invoiceDeleted = payload;
  },
  CHECKOUT_SUCCESSFULLY_DONE(state, payload) {
    state.checkoutSucceeded = payload;
  },
  SET_CALCULATED_TAX(state, payload) {
    state.calculatedTax = payload;
  },
  API_ERROR(state, payload) {
    if (payload) {
      state.apiError = payload;
    }
  },
  updateField,
};
